"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _reactFiles = _interopRequireDefault(require("react-files"));

var FILE_SIZE_MULTIPLIER = 10000000000;
var MAX_FILE_SIZE = 10 * FILE_SIZE_MULTIPLIER;
var MIN_FILE_SIZE = 1;

var DropZone = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(DropZone, _React$PureComponent);

  function DropZone() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, DropZone);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(DropZone)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "setFilePickerRef", function (ref) {
      if (_this._filePickerRef || !ref) {
        return;
      }

      _this._filePickerRef = ref;
    });
    return _this;
  }

  (0, _createClass2.default)(DropZone, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this._filePickerRef.removeFiles();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          accepts = _this$props.accepts,
          className = _this$props.className,
          clickable = _this$props.clickable,
          multiple = _this$props.multiple,
          minFileSize = _this$props.minFileSize,
          maxFileSize = _this$props.maxFileSize,
          children = _this$props.children,
          onChange = _this$props.onChange;
      return _react.default.createElement(_reactFiles.default, {
        className: "drop-zone ".concat(className || ''),
        dropActiveClassName: "drop-zone--active",
        onChange: onChange,
        onError: console.error,
        accepts: accepts,
        clickable: clickable || false,
        multiple: multiple || false,
        minFileSize: minFileSize || MIN_FILE_SIZE,
        maxFileSize: maxFileSize || MAX_FILE_SIZE,
        ref: this.setFilePickerRef
      }, children);
    }
  }]);
  return DropZone;
}(_react.default.PureComponent);

exports.default = DropZone;